module.exports = __webpack_public_path__ + "img/rabbit.13782881.png";